import React from 'react';
import ReactDOM from 'react-dom/client';
import 'bootstrap/dist/css/bootstrap.min.css';
import './index.css';
import { AuthProvider } from './context/AuthContext';
import ApiHealthMonitor from './components/ApiHealthMonitor';
import App from './App';
import reportWebVitals from './reportWebVitals';
import AppErrorBoundary from './components/AppErrorBoundary';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <AuthProvider>
      <ApiHealthMonitor />
      <AppErrorBoundary>
        <App />
      </AppErrorBoundary>
    </AuthProvider>
  </React.StrictMode>
);

reportWebVitals();

if (process.env.NODE_ENV === 'production' && 'serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register(`${process.env.PUBLIC_URL ?? ''}/sw.js`).catch(() => {
      /* Registration failed; app still works without offline/PWA install. */
    });
  });
}
